import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DashboardService } from '../pages/dashboard/services';
import { AuthService } from '../pages/auth/services';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class DashboardResolverService implements Resolve<any> {
  constructor(private dashboardService: DashboardService, private authService: AuthService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const fragment = route.fragment; // Directly access fragment from snapshot
    if (fragment) {
      const params = new URLSearchParams(fragment);
      const idToken = params.get('id_token');

      if (idToken) {
        const decodedToken: any = jwtDecode(idToken);
        const email = decodedToken?.email || decodedToken?.identities?.[0]?.userId;
        if (email) {
          const requestParams = {
            email: email,
            connection_pool: null
          };
          return this.authService.login(requestParams);
        }
      }
    }

    return of(null); // Return an observable with null if no token is found
  }
}
